import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = ({ 
  title = 'Professional ISO Certification Management',
  subtitle = 'Streamline your certification process with our comprehensive platform',
  primaryButtonText = 'Start Free Trial',
  primaryButtonHref = '/signup',
  secondaryButtonText = 'Book Demo',
  secondaryButtonHref = '/demo',
  backgroundImage = '',
  align = 'center',
  className = '' 
}) => {
  const alignClasses = {
    left: 'text-left items-start',
    center: 'text-center items-center',
    right: 'text-right items-end',
  };

  return (
    <section 
      className={`relative py-20 md:py-32 ${className}`}
      style={backgroundImage ? { 
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      } : {}}
    >
      {backgroundImage && (
        <div className="absolute inset-0 bg-black/50" />
      )}
      <div className={`container-wide relative z-10 flex flex-col ${alignClasses[align]}`}>
        <h1 className={`text-4xl md:text-5xl lg:text-6xl font-bold mb-6 max-w-4xl ${backgroundImage ? 'text-white' : ''}`}>
          {title}
        </h1>
        <p className={`text-lg md:text-xl mb-8 max-w-2xl ${backgroundImage ? 'text-white/90' : 'text-muted-foreground'}`}>
          {subtitle}
        </p>
        <div className={`flex flex-wrap gap-4 ${align === 'center' ? 'justify-center' : align === 'right' ? 'justify-end' : 'justify-start'}`}>
          {primaryButtonText && (
            <a 
              href={primaryButtonHref}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white rounded-md font-medium hover:bg-primary-hover transition-colors"
            >
              {primaryButtonText}
              <ArrowRight size={18} />
            </a>
          )}
          {secondaryButtonText && (
            <a 
              href={secondaryButtonHref}
              className={`inline-flex items-center gap-2 px-6 py-3 border rounded-md font-medium transition-colors ${
                backgroundImage 
                  ? 'border-white text-white hover:bg-white hover:text-black' 
                  : 'border-primary text-primary hover:bg-primary hover:text-white'
              }`}
            >
              {secondaryButtonText}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

Hero.builderConfig = {
  props: {
    title: {
      type: 'text',
      label: 'Title',
      default: 'Professional ISO Certification Management',
    },
    subtitle: {
      type: 'textarea',
      label: 'Subtitle',
      default: 'Streamline your certification process with our comprehensive platform',
    },
    primaryButtonText: {
      type: 'text',
      label: 'Primary Button Text',
      default: 'Start Free Trial',
    },
    primaryButtonHref: {
      type: 'text',
      label: 'Primary Button Link',
      default: '/signup',
    },
    secondaryButtonText: {
      type: 'text',
      label: 'Secondary Button Text',
      default: 'Book Demo',
    },
    secondaryButtonHref: {
      type: 'text',
      label: 'Secondary Button Link',
      default: '/demo',
    },
    backgroundImage: {
      type: 'image',
      label: 'Background Image',
      default: '',
    },
    align: {
      type: 'select',
      label: 'Alignment',
      default: 'center',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
  },
};

export default Hero;
